<template>
  <b-card
    no-body
  >
    <b-modal
      id="dpk-settings-modal"
      ref="confModalRef"
      title="Update .conf file"
      centered
      hide-footer
      size="lg"
      @hide="closeModal"
    >
      <b-form>
        <validation-observer ref="wifiSettingsModal">
          <b-row>
            <b-col md="12">
              <b-form-group
                label=""
                label-class="label-class"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file"
                  vid="list"
                  rules="required"
                >
                  <b-form-file
                    v-model="form.file"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept=".conf, .cfg"
                    :state="Boolean(form.file)"
                    class="upload-file"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
            >
              <b-button-request
                text="Update"
                :request="updateItem"
                class-container="d-flex justify-content-end"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BModal, BForm, BFormGroup, BFormFile,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, max } from '@validations'
import axios from '../axios-resolver'
import BButtonRequest from '../../../components/BButtonRequest.vue'

export default {
  components: {
    BButtonRequest,
    BRow,
    BCol,
    BCard,
    BModal,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormFile,
  },
  props: {
    fetchItems: {
      type: Function,
      default: () => {},
    },
    toUpload: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      max,
      id: null,
      form: {
        type: '',
        file: null,
      },
    }
  },
  watch: {
    toUpload() {
      console.log('this.toUpload', this.toUpload)

      if (this.toUpload) {
        this.$refs.confModalRef.show()
        this.id = this.toUpload.id
        this.form = {
          file: this.toUpload.file,
        }
      } else {
        this.$refs.confModalRef.hide()
      }
    },
  },
  methods: {
    async updateItem() {
      const valid = await this.$refs.wifiSettingsModal.validate()
      if (valid) {
        try {
          // create FormData and post to '/hardware/model-dpk-files'
          const formData = new FormData()
          if (typeof this.form.file === 'object') {
            formData.append('file', this.form.file)
          }

          const url = `/hardware/model/${this.id}/upload-config`
          await axios.post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          this.$bvModal.hide('wifi-settings-modal')
          this.closeModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success!',
              icon: 'BellIcon',
              variant: 'success',
            },
          })
        } catch (error) {
          if (error.response && error.response.status === 422) {
            const { fields } = error.response.data
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message,
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
            this.$refs.wifiSettingsModal.setErrors(fields)
          }
        }
      }
    },
    closeModal() {
      this.form = {}
      this.id = null
      this.fetchItems()
      this.$refs.confModalRef.hide()
    },
  },
}
</script>

<style lang="scss">
</style>
